import { useEffect, useRef } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { SplashScreen } from '@/shared/ui/components/SplashScreen';

import { useCustomAlerts } from '@/shared/lib/alert';

import { ROUTES } from '@/shared/constants';

import { saveReturnTo } from '../model/returnTo';

/**
 * Незалогиненный открыл ссылку на профиль актёра (/actors/:id?profile_token=…):
 * запоминаем путь и отправляем на вход — SignInPage вернёт сюда режиссёра.
 */
export const DirectorAccessRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showCustomAlert } = useCustomAlerts();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;
    hasRedirected.current = true;

    saveReturnTo(`${location.pathname}${location.search}`);
    showCustomAlert('Чтобы посмотреть профиль, войдите как кинокомпания', {
      severity: 'info'
    });
    navigate(ROUTES.auth.sign_in, { replace: true });
  }, []);

  return <SplashScreen />;
};
